import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
    padding: '0px 4px',
    width: '100%',
    height: '100%',
    background: 'none',
    border: 'none',
    margin: 0
  },
  pointer: {
    cursor: 'pointer'
  },
  default: {
    cursor: 'default'
  },
  displayValue: {
    fontSize: '14px',
    textAlign: 'left'
  },
  editImg: { height: '15px', width: '15px' },
  editableWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    width: '100%',
    height: '100%',
    padding: '0px 4px'
  },
  inputText: {
    width: '50px',
    height: '100%',
    border: 'none',
    background: 'transparent',
    fontSize: '14px',
    textAlign: 'left',
    outline: 'none',
    flex: 1
  },
  saveIcon: {
    padding: '0px',
    minWidth: '20px',
    width: '20px',
    height: '20px'
  },
  crossIcon: {
    padding: '0px',
    minWidth: '20px',
    width: '20px',
    height: '20px'
  }
}));
